<template>
  <div class="detalhe-por-vereador">
    <div class="row">
      <PublicHeader :title="'Emendas Por Vereador'">
        <div class="col-xs-12 col-sm-6">
          <p>
            Aqui você encontra as emendas parlamentares organizadas por
            vereador.
          </p>
          <p>
            No ano de <SelectAnoEmendas /> ,
            <ValorDestaqueHeader
              :value="vereadores.length"
              :isLoading="loading"
            />

            vereadores repassaram emendas paralamentares para a Prefeitura
            Municipal de Santos, no valor total de
            <ValorDestaqueHeader
              :value="formatarMoeda(valorTotalEmendas)"
              :isLoading="loading"
            />
            .
          </p>
          <p>
            Do total,
            <ValorDestaqueHeader
              :value="formatarMoeda(valorTotalUtilizado)"
              :isLoading="loading"
            />
            já foram utilizados, restando um saldo total de
            <ValorDestaqueHeader
              :value="formatarMoeda(saldoTotal)"
              :isLoading="loading"
            />
            .
          </p>
        </div>
      </PublicHeader>
    </div>
    <div class="container">
      <Breadcrumb :links="breadcrumb" />
      <div class="row form-group">
        <div class="col-xs-12">
          <h3>Total em emendas por vereador</h3>
        </div>
      </div>
      <div class="row">
        <div
          v-for="item in cardItems"
          :key="item.nome"
          class="col-xs-12 col-sm-6 col-md-4"
        >
          <CardEmendas :item="item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import {
  PublicHeader,
  Breadcrumb,
  CardEmendas,
  SelectAnoEmendas,
  ValorDestaqueHeader
} from '../../../components'
import { formatarMoeda } from '../../../utils'

export default {
  components: {
    PublicHeader,
    Breadcrumb,
    CardEmendas,
    SelectAnoEmendas,
    ValorDestaqueHeader
  },
  data() {
    return {
      breadcrumb: [
        {
          label: 'Emendas Parlamentares',
          named_link: { name: 'emendas_parlamentares' }
        },
        {
          label: 'Emendas Por Vereador'
        }
      ]
    }
  },

  methods: {
    formatarMoeda,
    reducer: key => (acum, emenda) => {
      return (acum += Number(emenda[key]))
    },
    getEmendasVereador(vereador) {
      const filter = emenda => {
        return emenda.vereador.nome === vereador
      }

      return this.emendas.filter(filter)
    },
    getValorFromVereador(vereador) {
      const emendas = this.getEmendasVereador(vereador)
      return emendas.reduce(this.reducer('valor'), 0)
    }
  },
  computed: {
    ...mapState({
      emendas: state => state.emendas_parlamentares.emendas,
      loading: ({ emendas_parlamentares }) => emendas_parlamentares.loading
    }),
    ...mapGetters(['valorTotalEmendas', 'saldoTotal', 'valorTotalUtilizado']),
    vereadores() {
      return [
        ...new Set(
          this.emendas.map(emenda => {
            return emenda.vereador.nome
          })
        )
      ]
    },
    cardItems() {
      const items = []
      this.vereadores.forEach(vereador => {
        items.push({
          nome: vereador,
          valor: this.getValorFromVereador(vereador),
          namedRoute: {
            name: 'emendas_detalhe_por_vereador',
            params: { vereador }
          }
        })
      })

      return items
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/public/emendas_parlamentares/EmendasPorVereador.vue